import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import './common.scss';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function CampaignPage() {
  return (
    <>
      <Helmet>
        <title> Users | Ckers </title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
            All Campaigns
        </Typography>
            <div id='main-wrap'>
                <div className='table-wrap'>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Campaign Name</th>
                            <th width='200'>Campaign Created Date</th>
                            <th>Source of Lead</th>
                            <th>Status</th>
                            <th>Assign To</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-primary text-white'>Active</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-primary text-white'>Active</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-danger text-white'>Pending</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-primary text-white'>Active</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-success text-white'>Closed</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Facebook Delhi</td>
                            <td>03-07-2023</td>
                            <td>Facebook</td>
                            <td>
                                <span className='badge text-bg-danger text-white'>Pending</span>
                            </td>
                            <td>Avinash, Rohit</td>
                            <td>
                                <div className="btn-group dropstart">
                                    <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical">&nbsp;</i>
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><i className="bi bi-eye">&nbsp;</i> View</li>
                                        <li><i className="bi bi-pen">&nbsp;</i> Edit</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
      </Container>
    </>
  );
}